import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Operation from '../../../../Models/Operation';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import Caisse from '../../../../Models/Caisse';
import Datas from "../../../../Data/Data.json"
import { InitBilletage } from '../../../../Functions/Traitement/ClearBilletage';
import { BilletageOperation } from '../../../../Models/BilletageOperation';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const EchangeManuelleCaisse = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(false)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<Pret[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false)
  const [pageIsLoad, setPageIsLoad] = useState(true)
  const [caisse, setCaisse] = useState<Caisse>()


  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  try {
    let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
    form.setFieldsValue((localData.form))

  } catch (error) {

  }


  useEffect(() => {
    forceUpdate({});

  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let so = form.getFieldValue("CODOPE")
    setRadioaCheck(false)
    setImpActive(true)
    //setData([])
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    localStorage.setItem(Data.LocalVariable.Mainreset, "1")
    form.setFieldValue("CODOPE", so)
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Echange manuel
        </span>
      ),
      children: <Tab3 form={form} caisse={caisse} />, //form={form}
    }
  ];

  const affiche = () => {
    let values: any = form.getFieldsValue()
    localStorage.clear()

    setImpActive(false)

    let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, values.DAT1ECHE, values.cssionApliq)
    console.log(Amort)

    setData(Amort.GetAmortissement() as [])

    form.setFieldsValue(Amortissement.totaux)

  };


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };



  if (pageIsLoad) {

    setPageIsLoad(false)
    LoadTillInformation()
  }


  function LoadTillInformation() {
    setLoading(true)
    let utilis: Utilisateur = user
    //alert(JSON.stringify(utilis))
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetTillStatut,
      headers: {
        'CipherUser': Crypter.encrypt(JSON.stringify(utilis)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          //props.form.setFieldsValue(res.Result[0])

          if (res.StatutCode == 200) {

            if (res.Message == 'Votre caisse est cloturé' || res.Message == 'Votre caisse est fermé') { // Lorsque la caisse est déjà ouverte

              navigate("/")
              SweetAlert.fire({ title: "Veillez au prélable ouvrir votre caisse", icon: "warning" })

            } else {
              InitBilletage({
                authHeader: authHeader(),
                form: form,
                value: '0'
              })
              InitBilletage({
                authHeader: authHeader(),
                form: form,
                value: '0',
                second: true
              })
              setCaisse(res.Result[0])
            }

          }
          else {
            navigate("/")
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        navigate("/")
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  const onFinish = (values: any) => {
    try {
      if (ReformatNumber(form.getFieldValue("TotalBilletage")) == ReformatNumber(form.getFieldValue("TotalBilletage_1"))) {
        var cai: Caisse = values
        cai.NODECE = caisse?.NODECE || ""
        cai.CAIUTI = caisse?.CAIUTI || ""
        cai.CDETAT = caisse?.CDETAT || ""
        cai.AEGECE = user.codage
        cai.Billetages = form.getFieldValue("Billetages")
        var billetage2 : BilletageOperation[] = form.getFieldValue("Billetages_1")

        var billetage2Tmp : BilletageOperation[] = []
        billetage2.map((b: BilletageOperation)=>{
          billetage2Tmp.push({
            codeBilletage: b.codeBilletage.replace("_1", ""),
            quantite: b.quantite,
            sens: b.sens,
            typeOperation: b.typeOperation,
            valeurUnitaire: b.valeurUnitaire
          })
        })
        cai.Billetages_1 = billetage2Tmp


        SweetAlert.fire({
          title: "Voulez vous faire l'échange de monnaie du montant de " + form.getFieldValue("TotalBilletage") + " Xaf?",
          showCancelButton: true,
          color: "green",
          confirmButtonText: "Yes",
          confirmButtonColor: "green",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            try {

              setLoading(true);
              setIsSubmit(true)

              let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.EchangeManuelle,
                headers: {
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
                data: Crypter.encrypt(JSON.stringify(cai)),
              };

              axios.request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                    if (res.StatutCode == 200) {
                      form.resetFields()
                      localStorage.clear()
                      setIsSubmit(false)
                      SweetAlert.fire({ title: res.Message, icon: "success" })
                      initialiazeButton()
                      localStorage.setItem(Data.LocalVariable.reset, "1")
                      initialiazeButton()
                      setSbmit("")

                      InitBilletage({
                        authHeader: authHeader(),
                        form: form,
                        value: '0'
                      })
                      InitBilletage({
                        authHeader: authHeader(),
                        form: form,
                        value: '0',
                        second: true
                      })

                    }
                    else {
                      SweetAlert.fire({ title: res.Message, icon: "warning" })
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: error, icon: "error" })
                })

            } catch (error) {
              SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
            }
          }
        })
      } else {
        SweetAlert.fire({ title: 'Bielletage incorrect', text: 'Les fonds en entrés doivent correspondre aux fonds en sortis', icon: "warning" })
      }
    } catch (error) {
      SweetAlert.fire({ title: 'Veuillez renseigner les billets à échanger', icon: "info" })
    }
  };
  function modif() {
    modifButton()

  }

  // function consult() {
  //   localStorage.setItem(Data.LocalVariable.reset, "1")
  //   //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
  //   let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
  //   let NUMSIMUL = form.getFieldValue("NUMSIMUL")

  //   if (data.length != 0) {
  //     initialiazeButton()
  //     setLoading(true)
  //     form.resetFields()
  //     form.setFieldValue('NUMSIMUL', NUMSIMUL)
  //     let config = {
  //       method: 'get',
  //       maxBodyLength: Infinity,
  //       url: Data.ApiUrl.GetSimulationPret,
  //       headers: {
  //         'CypherNumSimul': data,
  //         'Authorization': authHeader(),
  //         'Content-Type': 'application/json'
  //       },
  //     };
  //     axios.request(config)
  //       .then((response) => {
  //         setLoading(false);
  //         if (response.data) {
  //           const res = JSON.parse(Crypter.decrypt(response.data)).Value;

  //           console.log(res)
  //           if (res.StatutCode == 200) {
  //             form.setFieldsValue(res.Result.Table[0])
  //             form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
  //             form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
  //             //form.setFieldValue('', )

  //             localStorage.clear()

  //             //alert(JSON.stringify(res.Result.Table))

  //             initialiazeButton()

  //             cunsultButton()
  //             setEnregActve(false)


  //           }
  //           else {
  //             SweetAlert.fire({ title: res.Message, icon: "warning" })
  //           }
  //         }
  //         setLoading(false)
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.log(error)
  //         SweetAlert.fire({ title: error, icon: "error" })
  //       });
  //   }
  // }

  const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', data[newSelectedRowKeys]);
    form.setFieldsValue(data[newSelectedRowKeys])
    handleDemandePret()

    setSelectedRowKeys(newSelectedRowKeys);
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  function handleDemandePret() {

    localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("NUMDOS") + "|" + Data.LocalVariable.LoanStep.Demande);
    let numdos = form.getFieldValue("NUMDOS")

    if (data.length != 0) {
      form.setFieldValue('garantie', '')
      form.setFieldValue('avaliste', '')
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue('NUMDOS', numdos)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetPret,
        headers: {
          'CipherNumDos': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res)
            if (res.StatutCode == 200) {
              form.setFieldsValue(res.Result.Table[0])
              form.setFieldValue('DATEDEM', ReformatDate(res.Result.Table[0].DATEDEM));
              form.setFieldValue('DAT1ECHE', ReformatDate(res.Result.Table[0].DAT1ECHE));
              //form.setFieldValue('', )

              localStorage.clear()

              localStorage.setItem(Data.LocalVariable.garantie, Crypter.encrypt(JSON.stringify(res.Result.Table1)))
              localStorage.setItem(Data.LocalVariable.avaliste, Crypter.encrypt(JSON.stringify(res.Result.Table2)))
              localStorage.setItem('numcli', Crypter.encrypt(JSON.stringify(res.Result.Table[0].NUMCLI)))

              localStorage.setItem("garanties_client", Crypter.encrypt(JSON.stringify(res.Result.Table3)))
              localStorage.setItem("avalistes_client", Crypter.encrypt(JSON.stringify(res.Result.Table4)))

              localStorage.setItem('load_compte', "1")

              form.setFieldValue("cssionApliq", eval(res.Result.Table[0].MTNCOM1 + res.Result.Table[0].MTNCOM2 + res.Result.Table[0].MTNCOM3 + res.Result.Table[0].MTNCOM4 + res.Result.Table[0].MTNCOM5))
              console.log(JSON.stringify(res.Result.Table))

              localStorage.setItem(Data.LocalVariable.loadPret, "1")


              initialiazeButton()

              cunsultButton()
              setEnregActve(false)

            }
            else {
              localStorage.removeItem(Data.LocalVariable.reset)
              SweetAlert.fire({ title: res.Message, icon: "warning" })
              setSelectedRowKeys([])
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset)
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
          setSelectedRowKeys([])
        });
    }
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Data.LocalVariable.Mainreset)
      if (reset == "1") {
        setSelectedRowKeys([])
        localStorage.removeItem(Data.LocalVariable.Mainreset)
      }
    }
    catch (error) { }
  }, .1)

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Saisir
                </Button> */}
                <Button size='large' className='bt_add' onSubmit={onFinish} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={affiche} block>
                  Afficher
                </Button> */}
                {/* <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
                {/* <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button> */}
                <Button size='large' onClick={handleAnulle} className='bt_add' type="ghost" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default EchangeManuelleCaisse;